export default __webpack_public_path__ + "static/media/V545_CoC.fe6dbb5f.pdf";